import { UserLocationsListItemDto } from '../models';
import { sortByProperty } from './sort-by-property.util';

export function sortUserLocations(userLocations: UserLocationsListItemDto[]): UserLocationsListItemDto[] {
  return sortByProperty(userLocations, 'name');
}
